import React, { useEffect } from 'react';
import { useFilePicker } from 'use-file-picker';

const FilePicker = (props) => {
    const [openFileSelector, { filesContent }] = useFilePicker({  multiple: false, readAs: 'DataURL' });

    useEffect(() => {
        if (filesContent.length) {
            const dataUrl = filesContent[0].content;
            // props.values[props.inputName] = dataUrl;
            let event = { target: { name: props.inputName, value: dataUrl } }
            props.onChange(event);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filesContent]);

    return (
        <div>
            <div style={{ width: 'fit-content' }} onClick={() => openFileSelector()}>{props.children}</div>
            <div onClick={(e) => e.stopPropagation()}>
                {filesContent[0]?.name}
            </div>
        </div>);
};

export default FilePicker;
